<div class="gridContainer">
	<section class="runList">
		<sim-list icon="fa-cubes" [label]="T.TEAM_TRAINING_SESSION_DIALOG_STEP2_SCENARIO_LIST" [counter]="displayRuns().length">
			<ng-container actions>
				<sim-new-list-item
					(add)="addRun()"
					[disabled]="disableAddRun()"
					buttonLabel="BUTTON_ADD_ITEM"
					primaryLabel="TEAM_TRAINING_SESSION_DIALOG_STEP2_ADD_SCENARIO"
				/>
			</ng-container>
			@for (run of displayRuns(); track run.scenarioRecordingGroupId) {
				<sim-list-item
					[primaryLabel]="
						run.scenarioRecordingsMap?.at(0).scenarioName ?? T.TEAM_TRAINING_SESSION_DIALOG_STEP2_SCENARIO_LIST_ITEM_EMPTY_STATE
							| translate
					"
					[invalid]="step2Form.at($index).invalid"
					[selected]="currentRunIndex() === $index"
					(click)="currentRunIndex.set($index)"
					indicator="{{ $index + 1 }}"
					secondaryLabel="{{
						run.plannedStart && run.plannedEnd
							? (run.plannedStart | date: 'shortTime') + '-' + (run.plannedEnd | date: 'shortTime' :'': _translate.currentLang)
							: null
					}}"
				>
					<ng-container actions>
						<button
							mat-icon-button
							color="warn"
							[disabled]="displayRuns().length <= 1"
							(click)="removeRun(run.scenarioRecordingGroupId, $index)"
						>
							<mat-icon fontIcon="fa-times" fontSet="fa" />
						</button>
					</ng-container>
				</sim-list-item>
			}
		</sim-list>
	</section>
	@if (isReady) {
		<sim-labelled-container
			label="TEAM_TRAINING_SESSION_DIALOG_STEP2_ADD_SCENARIO"
			icon="fa-cube"
			class="inputForm"
			[class.visible]="isScenarioLoaded()"
		>
			<div class="formRow">
				<!--START TIME-->
				<sim-clock-time-input
					[labelKey]="T.SHARED_EVENT_SESSION_ESTIMATED_TIME_START"
					[formCtrl]="currentForm().controls.start"
					(onChange)="validateEndTimeBound()"
				/>

				<!--END TIME-->
				<sim-clock-time-input
					[labelKey]="T.SHARED_EVENT_SESSION_ESTIMATED_TIME_END"
					[formCtrl]="currentForm().controls.end"
					[min]="getEndTimeLimit()"
					(onChange)="validateEndTimeBound()"
				/>
			</div>

			<!--SCENARIO-->
			<sim-chip-autocomplete
				[dataType]="FetchDataType.Scenario"
				[formCtrl]="currentForm().controls.scenario"
				[labelToken]="T.CREATE_SESSION_DIALOG_ADD_SCENARIO"
				(onLoad)="isScenarioLoaded.set(true)"
				subscriptSizing="dynamic"
			>
				<mat-icon labelPrefix fontIcon="fa-ballot-check" fontSet="fad" />
			</sim-chip-autocomplete>
		</sim-labelled-container>
		<section class="inputForm">
			<sim-component-loading-container [isLoading]="!isScenarioLoaded()" [showBackDrop]="true" loadingIcon="fad fa-cubes" />
		</section>
	}
</div>
